/**
 * @generated SignedSource<<e1639302db5dc4297434f2b47b7378e3>>
 * @relayHash 671abbfcffd4b30389d639e41844176e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f2f7adbc07d4f80d51447bd24617827331324ba13e8ebb62a70854047d3b338d

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type people_peopleEditSearchQuery$variables = {
  id: string;
};
export type people_peopleEditSearchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentNew_suggestionsFragmentRef">;
};
export type people_peopleEditSearchQuery = {
  response: people_peopleEditSearchQuery$data;
  variables: people_peopleEditSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v2 = {
  "kind": "Literal",
  "name": "searchBy",
  "value": ""
},
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  (v2/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "people_peopleEditSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "people_issueFieldPeopleEditviewFull_PeopleEditViewWithFieldOptionsFragmentNew_suggestionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "people_peopleEditSearchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraUserConnection",
                "kind": "LinkedField",
                "name": "users",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountStatus"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "email"
                              }
                            ],
                            "type": "AtlassianAccountUser"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ],
                "storageKey": "users(first:50,searchBy:\"\")"
              },
              {
                "args": (v4/*: any*/),
                "filters": [
                  "searchBy"
                ],
                "handle": "connection",
                "key": "people_issueFieldPeopleEditviewFull_users",
                "kind": "LinkedHandle",
                "name": "users"
              }
            ],
            "type": "JiraPeopleField"
          },
          (v5/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "f2f7adbc07d4f80d51447bd24617827331324ba13e8ebb62a70854047d3b338d",
    "metadata": {},
    "name": "people_peopleEditSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a89e2b3c50541e9bcb98168ec5dcae35";

export default node;
